import SingleExpandAccordion from './SingleExpandAccordion';

export default SingleExpandAccordion;
